export const Permission = {
  POSTS_READ: 'posts:read',
  POSTS_WRITE: 'posts:write',
  TAGS_MANAGE: 'tags:manage',
  CATEGORIES_MANAGE: 'categories:manage',
  UPLOADS_WRITE: 'uploads:write',
  COMMENTS_MODERATE: 'comments:moderate',
  USERS_MANAGE: 'users:manage',
  NEWS_MANAGE: 'news:manage',
  ANALYTICS_VIEW: 'analytics:view',
  ANALYTICS_PURGE: 'analytics:purge',
  SYSTEM_VIEW: 'system:view',
  STATS_VIEW: 'stats:view',
  EMAIL_STATS_VIEW: 'email_stats:view',
  CV_MANAGE: 'cv:manage',
  ROLES_ASSIGN: 'roles:assign',
  EMAIL_SEND: 'email:send',
  EMAIL_TEMPLATES_WRITE: 'email_templates:write',
  AI_CONTENT_VIEW: 'ai_content:view',
  AI_CONTENT_MANAGE: 'ai_content:manage',
  AI_CONTENT_PUBLISH: 'ai_content:publish',
  OCI_REPEATER_MANAGE: 'oci_repeater:manage',
  CLAUDEX_SHARING: 'claudex:sharing',
} as const;

export type PermissionKey = typeof Permission[keyof typeof Permission];

export const ADMIN_ROLES = ['editor', 'moderator', 'admin', 'superadmin'] as const;

export const VALID_ROLES = ['user', 'editor', 'moderator', 'admin', 'superadmin'] as const;

export const ROLE_LABELS: Record<string, string> = {
  user: 'User',
  editor: 'Editor',
  moderator: 'Moderator',
  admin: 'Admin',
  superadmin: 'Super Admin',
};

export const ROLE_LEVEL: Record<string, number> = {
  user: 1,
  editor: 2,
  moderator: 2,
  admin: 3,
  superadmin: 4,
};

/** Check if caller (by their roles) can manage a target user (by their role string). */
export function canManageUser(callerRoles: string[], targetRoleStr: string): boolean {
  const callerLevel = Math.max(0, ...callerRoles.map((r) => ROLE_LEVEL[r] ?? 0));
  const targetRoles = targetRoleStr ? targetRoleStr.split(',').map((r) => r.trim()).filter(Boolean) : ['user'];
  const targetLevel = Math.max(0, ...targetRoles.map((r) => ROLE_LEVEL[r] ?? 0));
  return callerLevel > targetLevel;
}
